// For Sonar Fixing issue : Refactor this function to reduce its Cognitive Complexity to the 15 allowed.
export const AcceptTermsErrorUserDetails = () => {
    const getAcceptTermErrorUserDetails=(props)=>
    {
        return (
             props.formik.touched.acceptTerms && Boolean(props.formik.errors.acceptTerms)
        );
    }
    return {getAcceptTermErrorUserDetails}
}